import { Component, OnInit, OnDestroy } from "@angular/core";
import { ViewStateService } from "../../services/view-state.service";
import { Subscription } from "rxjs";

@Component({
  selector: "app-loading-spinner",
  templateUrl: "./loading-spinner.component.html",
})
export class LoadingSpinnerComponent implements OnInit, OnDestroy {
  isVisible: boolean;
  private stateSubscription: Subscription;

  constructor(private viewState: ViewStateService) {}

  ngOnInit() {
    this.stateSubscription = this.viewState.state$.subscribe((s) => {
      this.isVisible = s.isLoading;
    });
  }

  ngOnDestroy() {
    if (this.stateSubscription) {
      this.stateSubscription.unsubscribe();
    }
  }
}
